import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../context/LanguageContext';

/* 공장/설비 관리 화면 공통 헤더 — 공장 모니터링 헤더(fph-)와 같은 "아이콘 · 메뉴 › 화면" 경로 표시.
 * crumbs: [{ label, to? }] — to 가 있으면 눌러서 이동한다. 마지막 항목이 현재 화면.
 * backTo 가 있으면 왼쪽에 뒤로 가기 버튼, children 은 오른쪽 버튼 영역. 스타일은 management.css 의 mg-
 * rootLabel·icon 은 사이드바 메뉴 이름과 아이콘 (기본: 공장/설비관리). 회원관리 화면도 이 헤더를 쓴다. */
function ManagementHeader({ crumbs = [], backTo, rootLabel, icon = 'domain', children }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="mg-header">
      <div className="mg-breadcrumb">
        {backTo ? (
          <button type="button" className="mg-back" onClick={() => navigate(backTo)} title={t('common.back')}>
            <span className="material-symbols-outlined">arrow_back</span>
          </button>
        ) : (
          <span className="material-symbols-outlined mg-crumb-icon">{icon}</span>
        )}
        <span className="mg-crumb">{rootLabel || t('sidebar.management.title')}</span>
        {crumbs.map((c, i) => (
          <React.Fragment key={c.label}>
            <span className="material-symbols-outlined mg-crumb-sep">chevron_right</span>
            {c.to && i < crumbs.length - 1 ? (
              <button type="button" className="mg-crumb link" onClick={() => navigate(c.to)}>{c.label}</button>
            ) : (
              <span className={`mg-crumb ${i === crumbs.length - 1 ? 'current' : ''}`}>{c.label}</span>
            )}
          </React.Fragment>
        ))}
      </div>
      {children && <div className="mg-header-actions">{children}</div>}
    </div>
  );
}

export default ManagementHeader;
